import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseProxy } from "../base.proxy";

@Injectable()
export class UserActionTrackerProxy extends BaseProxy {
  /**
   *
   */
  constructor(_http: HttpClient) {
    super(_http);
  }

  account_requestcancel_supportemail() {
    return this._http.post('/ip/api/user/track/account/requestcancel/supportemail', {});
  }
}
